import { Card, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { getContentLanguage, Order } from '@/core';
import palette from '@/theme/palette';

export const OrderCompositionCard = ({ order }: { order: Order }) => {
  const { t, i18n } = useTranslation();
  return (
    <Stack direction={'column'} spacing={2}>
      <Typography variant="h2">{t('ORDER.COMPOSITION')}</Typography>
      <Card sx={{ backgroundColor: palette.surface.white, padding: 0 }}>
        <Stack
          direction={'row'}
          justifyContent={'start'}
          alignItems={'center'}
          gap={2}
          p={2}
          sx={{ backgroundColor: palette.surface.lighter }}
        >
          <Stack alignItems={'center'} justifyContent={'center'} sx={{ width: '60px' }}>
            <Typography variant="body1" fontWeight={500}>
              {t('ORDER.COUNT')}
            </Typography>
          </Stack>
          <Typography variant="body1" fontWeight={500}>
            {t('ORDER.NAME')}
          </Typography>
        </Stack>
        {order.order_data.items.map((item) => (
          <Stack
            key={item.id}
            direction={'row'}
            justifyContent={'start'}
            alignItems={'center'}
            gap={2}
            p={2}
          >
            <Stack alignItems={'center'} justifyContent={'center'} sx={{ width: '60px' }}>
              <Typography variant="body1">{item.amount}</Typography>
            </Stack>
            <Stack direction={'column'} justifyContent={'start'} alignItems={'start'}>
              <Typography variant="body1">
                {item.name[getContentLanguage(i18n.language)]}
              </Typography>
              {Object.values(item.selected_quizzes).map((selectedQuiz) => (
                <Typography key={`${order.id}${item.id}${selectedQuiz.id}`} variant="caption">
                  • {selectedQuiz.name[getContentLanguage(i18n.language)]}:{' '}
                  {Object.values(selectedQuiz.answers)
                    .map((answer) => {
                      if (answer.amount === 1) {
                        return answer.name[getContentLanguage(i18n.language)];
                      } else {
                        return `${answer.amount}x ${answer.name[getContentLanguage(i18n.language)]}`;
                      }
                    })
                    .join(', ')}
                </Typography>
              ))}
            </Stack>
          </Stack>
        ))}
      </Card>
    </Stack>
  );
};
